import {
  facebookEnquiry,
  facebookVenueFinder,
  facebookEvent,
} from "./facebook_events";
import {
  linkedinEnquiry,
  linkedinVenueFinder,
  linkedinEvent,
} from "./linkedin_events";
let lastEvent = null;
export const trackEvent = (event, data = {}) => {
  const serialised = JSON.stringify({ event, data });
  if (serialised === lastEvent) return;
  lastEvent = serialised;
  facebookEvent(event, data);
  linkedinEvent(event, data);
};
export const trackEnquiry = ({
  threadId,
  eventType,
  organiserType,
  budget,
  capacity,
}) => {
  facebookEnquiry({
    threadId,
    eventType,
    organiserType,
    budget,
    capacity,
  });
  linkedinEnquiry();
};

export const trackVenueFinder = (data) => {
  facebookVenueFinder(data);
  linkedinVenueFinder(data);
};
